import { cv } from "@suse-o11y/class-variance";
import { isPresent } from "@suse-o11y/is-present";
import React from "react";

import styles from "./_table.module.css";

const variants = cv(styles.row, {
	variants: {
		hoverable: {
			true: styles.hoverable,
		},
	},
});

export interface TableRowProps extends React.ComponentPropsWithoutRef<"div"> {
	/**
	 * - `true|false` adds hover interactions (gray background on hover).
	 * - `true` highlights the row with a light blue background.
	 *
	 * @default undefined
	 */
	isSelected?: boolean;

	/**
	 * Disables hover interactions and sets a cursor to "wait".
	 *
	 * @default false
	 */
	isLoading?: boolean;
}

export const TableRow = React.forwardRef<React.ComponentRef<"div">, TableRowProps>(
	({ isSelected, isLoading = false, className, ...props }, ref) => (
		<div
			aria-busy={isLoading}
			aria-selected={isSelected}
			className={variants({ hoverable: isPresent(isSelected), className })}
			ref={ref}
			role="row"
			{...props}
		/>
	),
);
